import type { CreateProductRequest } from '@/api/generated/schemas';
import type { SerieFormValues } from '../../serie';
import { TRANSPORT_TYPE_TO_API, normalizeNote, toResponsiblePersonInputs } from '../../serie';

/** Transformace hodnot formuláře na API request pro založení produktu (produkt + první série). */
export function toCreateProductRequest(values: SerieFormValues): CreateProductRequest {
  return {
    productName: values.productName.trim(),
    serieName: values.name.trim(),
    transportType: TRANSPORT_TYPE_TO_API[values.transportType],
    note: normalizeNote(values.note),
    responsiblePersons: toResponsiblePersonInputs(values),
  } satisfies CreateProductRequest;
}
